import axios from 'axios';
import cryptojs from 'crypto-js';
import * as msal from '@azure/msal-browser';
import router from '@/router';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;
const tenantId = process.env.VUE_APP_TENANT;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const apiHeaders = {
  'Content-Type': 'application/json',
  'Authorization': `Basic ${apiToken}`
};

let username = '';
let password = '';

function setToken(username, password) {
  const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
  store.commit('setToken', token);
}

const randomKeyGen = (length = 8) => {
  // Declare all characters
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  // Pick characers randomly
  let str = '';
  for (let i = 0; i < length; i++) {
      str += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return str;

};

const state = {
  loggedInUser: [],
  msalSsoEnabled: false,
  samllSsoEnabled: false,
  ldapEnabled: false,
  msalConfig: {},
  msalActiveAccount: null,
  msalUsername: '',
  samlUsername: '',
  samlResp: '',
  samlLoggedOut: false,
  ssoUserAdded: false,
  ldapAuthSuccess: false,
  ldapUserNotExist: ''
};

const getters = {
  loggedInUser: (state) => state.loggedInUser,
  msalSsoEnabled: (state) => state.msalSsoEnabled,
  samllSsoEnabled: (state) => state.samllSsoEnabled,
  msalConfig: (state) => state.msalConfig,
  msalActiveAccount: (state) => state.msalActiveAccount,
  msalUsername: (state) => state.msalUsername,
  samlUsername: (state) => state.samlUsername,
  ssoUserAdded: (state) => state.ssoUserAdded,
  ldapAuthSuccess: (state) => state.ldapAuthSuccess,
  ldapUserNotExist: (state) => state.ldapUserNotExist
};

const actions = {
  login({commit}, payload) {
    // Check tenant
    return axios.get(baseURL + '/tenant?userMember=' + payload.username, {headers: apiHeaders}).then( resp => {
      for (let i = 0; i < resp.data.length; i++) {
        if(resp.data[i].id == tenantId) {
          let data = {
            'username': payload.username, 
            'password': payload.password
          };
          // Authenticate
          return axios.post(baseURL + '/identity/verify', data, {headers: apiHeaders}).then( result => {
            // If user is authenticated
            if(result.data.authenticated) {
              // Get user details
              return axios.get(baseURL + '/user?id=' + payload.username, {headers: apiHeaders}).then( user => {
                username = payload.username;
                password = payload.password;
                setToken(username, password);
                store.commit('setCurrentUser', payload.username);
                store.commit('setCurrentUserFullname', user.data[0].firstName + ' ' + user.data[0].lastName);
                store.commit('setCurrentUserEmail', user.data[0].email);
                store.commit('setTenant', tenantId);
                store.commit('setEngineUrl', baseURL);
                let randomKey = randomKeyGen(512);
                store.commit('setRandomKey', randomKey);
                let cipher = cryptojs.AES.encrypt(payload.password, randomKey).toString();
                store.commit('setXAuthToken', cipher);
                let extCipher = cryptojs.AES.encrypt(apiPassword, randomKey).toString();
                store.commit('setExtAuthToken', extCipher);

                // Get user groups
                this.dispatch('getUserGroups');
                
                // Get user role
                return axios.get(baseURL + '/group?type=Role&member=' + username, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then(role => {
                  if(role.data.length > 0) {
                    store.commit('setCurrentRole', role.data[0].id);

                    // Check for admin role
                    if(role.data[0].id == 'adminRole') {
                      store.commit('setIsAdmin', true);
                    }

                    // Check for developer role
                    if(role.data[0].id == 'developerRole') {
                      store.commit('setIsDeveloper', true);
                    }

                    // Check for supervisor role
                    if(role.data[0].id == 'supervisorRole') {
                      store.commit('setIsSupervisor', true);
                    }

                    // Check for manager role
                    if(role.data[0].id == 'managerRole') {
                      store.commit('setIsManager', true);
                    }

                  }
                  commit('LOGGED_IN_USER', result.data);
                }).catch(error => {
                  throw new Error(`API ${error}`);
                });
              }).catch(error => {
                throw new Error(`API ${error}`);
              });
            }
          }).catch(error => {
            throw new Error(`API ${error}`);
          });
        }          
      }
    });
  },
  samlLogin({commit}) {
    let data = {
      'variables': {
        'sso': { 'value': 'saml', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/ssoController/start', data, {headers: apiHeaders}).then( resp => {
      let loginUrl = JSON.parse(resp.data.variables.samlLoginUrl.value);

      window.open(loginUrl);
      commit('SAML_RESP', resp);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  completeSsoLogin({state, commit}, payload) {
    // Check tenant
    return axios.get(baseURL + '/tenant?userMember=' + payload.username, {headers: apiHeaders}).then( resp => {
      for (let i = 0; i < resp.data.length; i++) {
        if(resp.data[i].id == tenantId) {
          // Get user details
          return axios.get(baseURL + '/user?id=' + payload.username, {headers: apiHeaders}).then( user => {
            store.commit('setToken', apiToken);
            store.commit('setCurrentUser', user.data[0].id);
            store.commit('setCurrentUserFullname', user.data[0].firstName + ' ' + user.data[0].lastName);
            store.commit('setCurrentUserEmail', user.data[0].email);
            store.commit('setTenant', tenantId);
            store.commit('setEngineUrl', baseURL);
            let randomKey = randomKeyGen(512);
            store.commit('setRandomKey', randomKey);
            let cipher = cryptojs.AES.encrypt(payload.password, randomKey).toString();
            store.commit('setXAuthToken', cipher);
            let extCipher = cryptojs.AES.encrypt(apiPassword, randomKey).toString();
            store.commit('setExtAuthToken', extCipher);

            // Sync the users LDAP password to Harlequin
            if(state.ldapEnabled) {
              let decipher = cryptojs.AES.decrypt(store.state.extAuthToken, store.state.randomKey);
              let credData = {
                'password': payload.password,
                'authenticatedUserPassword': decipher.toString(cryptojs.enc.Utf8)
              };
              axios.put(baseURL + '/user/' + payload.username + '/credentials', credData, {headers: apiHeaders}).then( res => {
                if(res.status == 204) {
                  commit('UPDATED_USER_CREDS', payload.username); 
                }
              }).catch(error => {
                throw new Error(`API ${error}`);
              });
            }

            let loggedInData = {
              'authenticatedUser': payload.username,
              'authenticated': true
            }
            
            // Get user groups
            this.dispatch('getUserGroups');
            
            // Get user role
            return axios.get(baseURL + '/group?type=Role&member=' + payload.username, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then(role => {
              if(role.data.length > 0) {
                store.commit('setCurrentRole', role.data[0].id);

                // Check for admin role
                if(role.data[0].id == 'adminRole') {
                  store.commit('setIsAdmin', true);
                }

                // Check for supervisor role
                if(role.data[0].id == 'supervisorRole') {
                  store.commit('setIsSupervisor', true);
                }

                // Check for manager role
                if(role.data[0].id == 'managerRole') {
                  store.commit('setIsManager', true);
                }

              }
              if(state.msalSsoEnabled) {
                commit('MSAL_USERNAME', payload.msalUsername);
              }
              if(state.samlSsoEnabled) {
                commit('SAML_USERNAME', payload.samlUsername);
              }
              commit('LOGGED_IN_USER', loggedInData);
            }).catch(error => {
              throw new Error(`API ${error}`);
            });
          }).catch(error => {
            throw new Error(`API ${error}`);
          });
        }else {
          // Do nothing
        }
      }
      if(resp.data.length === 0 && !state.ssoUserAdded) {
        store.commit('setToken', apiToken);
        let name = payload.name.split(' ');
        let firstName = 'NULL';
        let lastName = 'NULL';
        
        if(name[0]) {
          firstName = name[0];
        }
        if(name[1]) {
          lastName = name[1];
        }

        // Generate password
        let newPass = '';
        let length = 2;
        let chars = 'abcdefghijklmnopqrstuvwxyz';

        // Generate ID
        for (let i = 0; i < length; i++) {
          newPass += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        length = 1;
        chars = '!@$%^&*';

        // Generate ID
        for (let i = 0; i < length; i++) {
          newPass += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        length = 1;
        chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

        // Generate ID
        for (let i = 0; i < length; i++) {
          newPass += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        length = 1;
        chars = '0123456789';

        // Generate ID
        for (let i = 0; i < length; i++) {
          newPass += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        length = 7;
        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@$%^&*';

        // Generate ID
        for (let i = 0; i < length; i++) {
          newPass += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        let userEmail = '';
        if(state.msalSsoEnabled) {
          userEmail = payload.msalUsername;
        }
        if(state.samlSsoEnabled) {
          userEmail = payload.samlUsername;
        }

        let userPayload = {
          'profile': {
            'id': payload.username,
            'firstName': firstName,
            'lastName': lastName,
            'email': userEmail
          },
          'credentials': {
            'password': newPass
          }
        };
        this.dispatch('addUser', userPayload).then(() => {

          let rolePayload = {
            'id': 'userRole',
            'userId': payload.username
          };
          this.dispatch('addUserToRole', rolePayload).then( () => {
            commit('SSO_USER_ADDED', true);
          });
        });
      }
    });
  },
  samlAuthCheck({commit}) {
    return axios.get(window.location.origin + '/saml/check.jsp', {headers: {'Content-Type': 'application/json'}}).then( resp => {
      let isAuthenticated = resp.data.samlResponse[0].isAuthenticated;
      let samlLogout = resp.data.samlResponse[0].samlLogout;

      if(!isAuthenticated && samlLogout) {
        commit('SAML_LOGGED_OUT', true);
        // Clearing data
        commit('OP_LOG', []);
        commit('COMPLETED_INSTANCES', []);
        commit('ALL_TASKS', []);
        commit('UNASSIGNED_TASKS', []);
        commit('TEAM_TASKS', []);
        commit('MY_TASKS', []);
        commit('RUNNING_PROCESSES', []);
        commit('PROCESSES', []);
        commit('ALL_PROCESSES', []);
        commit('ALL_PROCESS_XML', []);
        commit('ALL_TABLES', []);
        commit('ALL_FORMS', []);
        commit('DOC_TEMPLATES', []);
        commit('EMAIL_TEMPLATES', []);
        commit('ALL_REPORTS', []);
        commit('ALL_FILES', []);
        commit('ALL_USERS', []);
        commit('ALL_USERS_SPECIAL', []);
        commit('ALL_PORTAL_USERS', []);
        commit('ALL_GROUPS', []);
        commit('HIST_DATES_CLEARED', false);

        // Update Ops log
        let msg = 'User ' + store.state.currentUser + ' logged out.';
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': 'Admin',
          'userId': store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': 'Logout',
          'msg': msg,
          'dateTime': dateTime,
        };
        this.dispatch('updateOpLog', logData);
        
        this.dispatch('unlockAll').then( async () => {
          await this.dispatch('logout')
          .then(() => {
            this.dispatch('redirectToLogin');
          });
        });
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async ldapLogin({commit}, payload) {

    let hqUsername = payload.username;

    if(hqUsername.includes("\\")) {
      hqUsername = hqUsername.split('\\')[1];
    }
    hqUsername = hqUsername.replace(/[^A-Z0-9]/ig, "");
    
    await this.dispatch('userCheck', hqUsername).then( exists => {
      if(exists) {
        let data = {
          'variables': {
            'requestType': { 'value': 'login', 'type': 'String' },
            'ldapUsername': { 'value': payload.username, 'type': 'String' },
            'ldapPassword': { 'value': payload.password, 'type': 'String' }
          },
          'withVariablesInReturn': true
        };
    
        return axios.post(baseURL + '/process-definition/key/ldapController/tenant-id/' + tenantId + '/start', data, {headers: apiHeaders}).then( resp => {
          let ldapAuthSuccess = resp.data.variables.ldapAuthSuccess.value;

          commit('LDAP_AUTH_SUCCESS', ldapAuthSuccess);
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }else {
        commit('LDAP_USER_NOT_EXIST', "This account has not been sync'ed to Harlequin. Attempting local login...");
      }
    });
  },
  redirectToLogin() {
    router.push('/');
  },
  async logout({state, commit}) {
    let username = store.state.currentUser;

    if(state.msalSsoEnabled && username != 'hqadmin') {
      const msalObj = new msal.PublicClientApplication(state.msalConfig);

      const logoutReq = {
        account: msalObj.getAccountByUsername(state.msalUsername)
      }
      msalObj.logoutPopup(logoutReq);
    }

    if(state.samlSsoEnabled && !state.samlLoggedOut && username != 'hqadmin') {
      let samlUrl = window.location.origin + '/saml/logout.jsp';
      window.location.href = samlUrl;
    }

    // let data = {
    //   'loggedInUser': [],
    //   'msalSsoEnabled': false,
    //   'samlSsoEnabled': false
    // };
    this.dispatch('clearAll');

    commit('LOGGED_OUT_USER');

    return true;
  }
};

const mutations = {
  LOGGED_IN_USER(state, payload) {
    state.loggedInUser = payload;
    store.commit('setIsLoggedIn', true);
  },
  MSAL_SSO_ENABLED(state, payload) {
    state.msalSsoEnabled = payload;
    store.commit('setMsalSsoEnabled', true);
    store.commit('setSamlSsoEnabled', false);
  },
  SAML_SSO_ENABLED(state, payload) {
    state.samlSsoEnabled = payload;
    store.commit('setSamlSsoEnabled', true);
    store.commit('setMsalSsoEnabled', false);
  },
  LDAP_ENABLED(state, payload) {
    state.ldapEnabled = payload;
  },
  MSAL_CONFIG(state, payload) {
    state.msalConfig = payload;
  },
  MSAL_ACTIVE_ACCOUNT(state, payload) {
    state.msalActiveAccount = payload;
  },
  MSAL_USERNAME(state, payload) {
    state.msalUsername = payload;
  },
  SAMLL_USERNAME(state, payload) {
    state.samlUsername = payload;
  },
  SSO_USER_ADDED(state, payload) {
    state.ssoUserAdded = payload;
  },
  SAML_RESP(state, payload) {
    state.samlResp = payload;
  },
  SAML_LOGGED_OUT(state, payload) {
    state.samlLoggedOut = payload;
  },
  LDAP_AUTH_SUCCESS(state, payload) {
    state.ldapAuthSuccess = payload;
  },
  LDAP_USER_NOT_EXIST(state, payload) {
    state.ldapUserNotExist = payload;
  },
  LOGGED_OUT_USER() {
    // state.loggedInUser = payload.loggedInUser;
    // state.msalSsoEnabled = payload.msalSsoEnabled;
    // state.samlSsoEnabled = payload.samlSsoEnabled;
    store.commit('setIsLoggedIn', false);
    store.commit('setMsalSsoEnabled', false);
    store.commit('setSamlSsoEnabled', false);
    store.commit('setLdapEnabled', false);
    // sessionStorage.setItem('vuex', '');
    // sessionStorage.removeItem('vuex');
    sessionStorage.clear();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}